import { render, staticRenderFns } from "./LoginClienteAndComerciante.vue?vue&type=template&id=8b1e1042&"
import script from "./LoginClienteAndComerciante.vue?vue&type=script&lang=js&"
export * from "./LoginClienteAndComerciante.vue?vue&type=script&lang=js&"
import style0 from "./LoginClienteAndComerciante.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports